import { Button, Layout, Space, Tabs } from "antd";
import Toolbar from "../shared-components/Toolbar";
import PendingItems from "../containers/orders/PendingItems";

function OrdersPageV2() {
  return (
    <Layout>
      <Space>
        <h1>External income orders</h1>
      </Space>
      <Space>
        <Tabs defaultActiveKey="ordered">
          <Tabs.TabPane tab="Ordered" key="ordered">
            <Space direction="vertical">
              <Toolbar>
                <Button>Refresh</Button>
              </Toolbar>
              <Space>
                Current ordered items
              </Space>
            </Space>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Pending" key="pending">
            <PendingItems />
          </Tabs.TabPane>
          <Tabs.TabPane tab="To order" key="toOrder">
            Items to order
          </Tabs.TabPane>
          <Tabs.TabPane tab="Tracking" key="tracking">
            Tracking information
          </Tabs.TabPane>
          <Tabs.TabPane tab="Recipients" key="recipients">
            Recipients
          </Tabs.TabPane>
        </Tabs>
      </Space>
    </Layout>
  );
}

export default OrdersPageV2;
